export * from './account.service';
import { AccountService } from './account.service';
export * from './appSetting.service';
import { AppSettingService } from './appSetting.service';
export * from './auditTrail.service';
import { AuditTrailService } from './auditTrail.service';
export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './barcodeImage.service';
import { BarcodeImageService } from './barcodeImage.service';
export * from './barcodeTester.service';
import { BarcodeTesterService } from './barcodeTester.service';
export * from './customer.service';
import { CustomerService } from './customer.service';
export * from './customerClass.service';
import { CustomerClassService } from './customerClass.service';
export * from './customerOrder.service';
import { CustomerOrderService } from './customerOrder.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './dimension.service';
import { DimensionService } from './dimension.service';
export * from './documentNumberSetting.service';
import { DocumentNumberSettingService } from './documentNumberSetting.service';
export * from './documentType.service';
import { DocumentTypeService } from './documentType.service';
export * from './gPItemClass.service';
import { GPItemClassService } from './gPItemClass.service';
export * from './gPSalesType.service';
import { GPSalesTypeService } from './gPSalesType.service';
export * from './gPSite.service';
import { GPSiteService } from './gPSite.service';
export * from './gPUser.service';
import { GPUserService } from './gPUser.service';
export * from './help.service';
import { HelpService } from './help.service';
export * from './helpCategory.service';
import { HelpCategoryService } from './helpCategory.service';
export * from './helpTopic.service';
import { HelpTopicService } from './helpTopic.service';
export * from './internalTransfer.service';
import { InternalTransferService } from './internalTransfer.service';
export * from './invTran.service';
import { InvTranService } from './invTran.service';
export * from './invTranType.service';
import { InvTranTypeService } from './invTranType.service';
export * from './inventoryCounting.service';
import { InventoryCountingService } from './inventoryCounting.service';
export * from './inventoryCountingRevision.service';
import { InventoryCountingRevisionService } from './inventoryCountingRevision.service';
export * from './item.service';
import { ItemService } from './item.service';
export * from './itemExternalUPC.service';
import { ItemExternalUPCService } from './itemExternalUPC.service';
export * from './itemSetting.service';
import { ItemSettingService } from './itemSetting.service';
export * from './labelTemplate.service';
import { LabelTemplateService } from './labelTemplate.service';
export * from './labelTransaction.service';
import { LabelTransactionService } from './labelTransaction.service';
export * from './location.service';
import { LocationService } from './location.service';
export * from './locationSetting.service';
import { LocationSettingService } from './locationSetting.service';
export * from './locationSite.service';
import { LocationSiteService } from './locationSite.service';
export * from './permission.service';
import { PermissionService } from './permission.service';
export * from './priceList.service';
import { PriceListService } from './priceList.service';
export * from './printerDeviceAssignment.service';
import { PrinterDeviceAssignmentService } from './printerDeviceAssignment.service';
export * from './productRepository.service';
import { ProductRepositoryService } from './productRepository.service';
export * from './role.service';
import { RoleService } from './role.service';
export * from './rolePermission.service';
import { RolePermissionService } from './rolePermission.service';
export * from './scanDocument.service';
import { ScanDocumentService } from './scanDocument.service';
export * from './scanDocumentType.service';
import { ScanDocumentTypeService } from './scanDocumentType.service';
export * from './site.service';
import { SiteService } from './site.service';
export * from './taskProcess.service';
import { TaskProcessService } from './taskProcess.service';
export * from './timeZone.service';
import { TimeZoneService } from './timeZone.service';
export * from './traceabilityManagement.service';
import { TraceabilityManagementService } from './traceabilityManagement.service';
export * from './transferInventory.service';
import { TransferInventoryService } from './transferInventory.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './userSetting.service';
import { UserSettingService } from './userSetting.service';
export * from './utilHelper.service';
import { UtilHelperService } from './utilHelper.service';
export * from './vendorClass.service';
import { VendorClassService } from './vendorClass.service';
export * from './webReporting.service';
import { WebReportingService } from './webReporting.service';
export * from './workflowSatus.service';
import { WorkflowSatusService } from './workflowSatus.service';
export const APIS = [AccountService, AppSettingService, AuditTrailService, AuthenticationService, BarcodeImageService, BarcodeTesterService, CustomerService, CustomerClassService, CustomerOrderService, DashboardService, DimensionService, DocumentNumberSettingService, DocumentTypeService, GPItemClassService, GPSalesTypeService, GPSiteService, GPUserService, HelpService, HelpCategoryService, HelpTopicService, InternalTransferService, InvTranService, InvTranTypeService, InventoryCountingService, InventoryCountingRevisionService, ItemService, ItemExternalUPCService, ItemSettingService, LabelTemplateService, LabelTransactionService, LocationService, LocationSettingService, LocationSiteService, PermissionService, PriceListService, PrinterDeviceAssignmentService, ProductRepositoryService, RoleService, RolePermissionService, ScanDocumentService, ScanDocumentTypeService, SiteService, TaskProcessService, TimeZoneService, TraceabilityManagementService, TransferInventoryService, UserService, UserSettingService, UtilHelperService, VendorClassService, WebReportingService, WorkflowSatusService];
